<script>
export default {
  render () {
    return (
      <router-view />
    );
  },
};
</script>
